import { formatMessage } from '@99designs/common/i18n';
import { handlePromise } from 'common/utils/Bugsnag';
import loadImage from 'common/utils/loadImage';
import { StepState } from 'projects/util/step';
import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

export default class Artwork<T> extends React.Component<{ step: StepState<T> }> {
    static hasDonePreload = false;

    componentDidMount() {
        if (!Artwork.hasDonePreload) {
            this.props.step.steps.map(step => {
                if (step.backgroundImage) {
                    handlePromise(loadImage(step.backgroundImage), 'Artwork');
                }
            });
            Artwork.hasDonePreload = true;
        }
    }

    render() {
        const { step } = this.props;
        const currentStep = step.currentStep();

        let image = <div className="artwork" data-step={step.number} />;

        if (currentStep.backgroundImage) {
            image = (
                <div className="artwork" data-step={step.number}>
                    <img
                        className="artwork__image"
                        data-step={step.number}
                        src={currentStep.backgroundImage}
                    />
                    <div className="artwork__attribution">
                        <span className="attribution">
                            {formatMessage(__('by {designer}'), { designer: 'Molecula' })}
                        </span>
                    </div>
                </div>
            );
        }

        return (
            <TransitionGroup>
                <CSSTransition key={step.number} timeout={1000} classNames="fade">
                    {image}
                </CSSTransition>
            </TransitionGroup>
        );
    }
}
